import { buildModelManager } from "../builder.js";
const DefaultShopifyInventoryItemSelection = {
  __typename: true,
  id: true,
  cost: true,
  countryCodeOfOrigin: true,
  countryHarmonizedSystemCodes: true,
  createdAt: true,
  duplicateSkuCount: true,
  harmonizedSystemCode: true,
  inventoryHistoryUrl: true,
  legacyResourceId: true,
  measurement: true,
  provinceCodeOfOrigin: true,
  requiresShipping: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  sku: true,
  tracked: true,
  trackedEditable: true,
  unitCost: true,
  updatedAt: true,
  weightUnit: true,
  weightValue: true
};
const modelApiIdentifier = "shopifyInventoryItem";
const pluralModelApiIdentifier = "shopifyInventoryItems";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyInventoryItemSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyInventoryItemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyInventoryItem does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyInventoryItemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyInventoryItemSelection,
  operations
);
export {
  DefaultShopifyInventoryItemSelection,
  ShopifyInventoryItemManager
};
//# sourceMappingURL=ShopifyInventoryItem.js.map
